/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal__footer-action[_ngcontent-%COMP%]{-ms-flex:1 1;flex:1 1}.modal__footer-action[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
